import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import Util from "../../Util"
import * as ApiHelper from "../../ApiHelper"
import Moment from "moment"
import { TableLayout } from "../../components"
import { ToastContainer, ToastMessage } from "react-toastr"
import { LoadModal } from "../modais";
class TableNotasFiscaisNav extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.print = this.print.bind(this)
    this.state = {
      showLoad: false
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(event, id) {
    ApiHelper.deleteNota(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        this.props.onDelete()
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  print() {
    this.toggleLoadModal()
    ApiHelper.getRelacaoNotasFiscais(this.props.contratoID, (file, error) => {
      this.toggleLoadModal()
      if (file) {
        var date = new Date()
        var dateString =
          (date.getDate() + "").padStart(2, "0") +
          "-" +
          (date.getMonth() + "").padStart(2, "0") +
          "-" +
          date.getFullYear()

        var url = URL.createObjectURL(file)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Relação de notas fiscais-" + dateString + ".pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  render() {
    var tableHeaders = [
      "Número da nota fiscal",
      "Data da nota fiscal",
      "Número de itens baixados",
      "Número do contrato",
      "Objeto do contrato",
      "Valor da nota",
      "Ações"
    ]
    var buttons = [
      {
        title: "Notas fiscais deletadas",
        link: "/notas/trash/" + this.props.contratoID,
        icon: "delete"
      }
    ]
    const additionalButtons = [
      {
        title: "Imprimir",
        callBack: this.print,
        icon: "print"
      }
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          additionalButtons={additionalButtons}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar nota fiscal"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-1">{row.numero}</td>
                    <td className="col-sm-1">
                      {Moment(row.data).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-1">{row.itens_nota.length}</td>
                    <td className="col-sm-1">{row.contrato.num_contrato}</td>
                    <td className="col-sm-6">{row.contrato.objeto}</td>
                    <td className="col-sm-2">
                      {Util.formatCurrency(parseFloat(row.valor))}
                    </td>
                    <td className="td-actions text-right">
                      <Link
                        title="Editar nota"
                        className="btn btn-primary btn-simple btn-xs"
                        to={"/notas/edit/" + row.id}
                      >
                        <i className="material-icons">edit</i>
                      </Link>
                      <button
                        title="Deletar nota"
                        className="btn btn-danger btn-simple btn-xs"
                        onClick={event => this.delete(event, row.id)}
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableNotasFiscaisNav)



// WEBPACK FOOTER //
// ./src/views/baixas/TableNotasFiscais.js